export const satisfactionsEntity = `satisfactions`;
//# sourceMappingURL=index.js.map